import { render, staticRenderFns } from "./MobileSafetyRegularAssessmentAlwaysUpdate.vue?vue&type=template&id=2d21f8a0&scoped=true&"
import script from "./MobileSafetyRegularAssessmentAlwaysUpdate.vue?vue&type=script&lang=js&"
export * from "./MobileSafetyRegularAssessmentAlwaysUpdate.vue?vue&type=script&lang=js&"
import style0 from "./MobileSafetyRegularAssessmentAlwaysUpdate.vue?vue&type=style&index=0&id=2d21f8a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d21f8a0",
  null
  
)

export default component.exports